import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, MenuItem } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./CreateRoleDialog.scss";
import "./../../../../styles.scss"

interface CreateRoleDialogProps {
    open: boolean;
    onClose: () => void;
    onCreate: (roleName: string, cloneRole: string) => void;
    roles: Array<{ name: string }>;
}

const CreateRoleDialog: React.FC<CreateRoleDialogProps> = ({ open, onClose, onCreate, roles }) => {
    const formik = useFormik({
        initialValues: {
            roleName: "",
            cloneRole: "",
        },
        validationSchema: Yup.object({
            roleName: Yup.string()
                .required("Role name is required")
                .min(3, "Role name must be at least 3 characters")
                .max(25, "Role name must not exceed 25 characters")
                .matches(/^[a-zA-Z0-9]+$/, "Role name must contain only alphabets and numbers"),
            cloneRole: Yup.string()
                .required("Please select a role to clone"),
        }),
        onSubmit: (values) => {
            onCreate(values.roleName, values.cloneRole);
            formik.resetForm();
            onClose();
        },
    });

    return (
        <Dialog sx={{
            "& .MuiDialog-paper": {
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "380px",
                height: "350px",
                transform: "translate(-50%, -50%)",
            },
        }} open={open} onClose={onClose} fullWidth>
            <DialogTitle className="dialog-title">Create Role</DialogTitle>
            <DialogContent>
                <p className="dialog-content">Name the title of the role you would like to create</p>
                <form onSubmit={formik.handleSubmit}>
                    <TextField
                        sx={{ marginTop: "20px" }}
                        label="Role Name"
                        fullWidth
                        name="roleName"
                        value={formik.values.roleName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.roleName && Boolean(formik.errors.roleName)}
                        helperText={formik.touched.roleName && formik.errors.roleName}
                    />
                    <TextField
  select
  label="Clone Role"
  fullWidth
  name="cloneRole"
  value={formik.values.cloneRole}
  onChange={formik.handleChange}
  onBlur={formik.handleBlur}
  margin="normal"
  error={formik.touched.cloneRole && Boolean(formik.errors.cloneRole)}
  helperText={formik.touched.cloneRole && formik.errors.cloneRole}
  SelectProps={{
    MenuProps: {
      PaperProps: {
        sx: {
          maxHeight: 200,
          padding: 0,
        },
      },
    },
  }}
>
{roles.map((role: any) => (
  <MenuItem
    key={role.id}
    value={role.id}
    sx={{
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1.4,
    }}
  >
    {role.name}
  </MenuItem>
))}
</TextField>
                </form>
            </DialogContent>
            <DialogActions sx={{ display: "flex", gap: "10px", justifyContent: "center", marginBottom: "15px" }}>
                <Button
                    sx={{ width: "120px" }}
                    onClick={() => {
                        formik.resetForm();
                        onClose();
                    }}
                    variant="outlined">
                    Cancel
                </Button>
                <Button
                    sx={{ width: "120px" }}
                    variant="contained"
                    color="primary"
                    className={`btn btn-primary`}
                    type="submit"
                    onClick={() => formik.handleSubmit()}
                    disabled={!formik.isValid || formik.isSubmitting}>
                    Create Role
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateRoleDialog;